import type { FC } from 'react'
import React from 'react'
import './table-row.css'

// Extends the intrinsic props so a caller can hang `data-*` on a row; the e2e
// scenes select rows that way rather than by their text.
export interface TableRowProps
    extends React.HTMLAttributes<HTMLTableRowElement> {
    containerRef?: React.RefObject<HTMLTableRowElement>
    children: React.ReactNode
}

export const TableRow: FC<TableRowProps> = ({
    containerRef,
    children,
    ...rest
}) => {
    return (
        <tr
            ref={containerRef}
            className="table-row"
            style={{
                borderTop: '0.5rem solid transparent',
                borderBottom: '0.5rem solid transparent',
            }}
            {...rest}>
            {children}
        </tr>
    )
}
